import React from "react";
import { Routes, Route, HashRouter, Navigate } from "react-router-dom";

import Home from '../pages/Home';
const SearchPage = React.lazy(() => import('../pages/Search'));
const GraphPage = React.lazy(() => import('../pages/GraphPage'));
const MapPage = React.lazy(() => import('../pages/Map'));
const AnalyticsPage = React.lazy(() => import('../pages/AnalyticsPage'));
const ProcessFlowPage = React.lazy(() => import('../pages/ProcessFlowPage'));
// AuditLogPage is handled inside GraphPage (admin sub-route)
import PrivateRoute from './PrivateRoute';
import { TabProvider } from '../context/TabContext.jsx';
import {
  ANALYTICS_VIEW_PATH,
  LEGACY_ANALYTICS_VIEW_PATH,
  LEGACY_PROCESS_VIEW_PATH,
  MAP_VIEW_PATH,
  PROCESS_FLOW_PATH,
  PROCESS_VIEW_PATH,
  SEARCH_PATH,
} from '../constants/routes.js';

const RouteFallback = () => null;

const AppRoutes = () => {
  React.useEffect(() => {
    const browserRuntime = globalThis;
    const currentHash = String(browserRuntime.location?.hash || '');
    if (!currentHash.startsWith('#/map')) {
      return undefined;
    }

    const preloadMapChunks = () => {
      void import('../pages/Map');
      void import('../components/GeoMap/GeoMapLanding');
      void import('../components/GeoMap/LandingMap');
    };

    if (typeof browserRuntime.requestIdleCallback === 'function') {
      const handle = browserRuntime.requestIdleCallback(preloadMapChunks, { timeout: 2500 });
      return () => browserRuntime.cancelIdleCallback?.(handle);
    }

    const timeoutHandle = browserRuntime.setTimeout(preloadMapChunks, 1500);
    return () => browserRuntime.clearTimeout(timeoutHandle);
  }, []);

  return (
    <TabProvider>
      <React.Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path={MAP_VIEW_PATH} element={<PrivateRoute><MapPage /></PrivateRoute>} />
          <Route index path={SEARCH_PATH} element={<PrivateRoute><SearchPage /></PrivateRoute>} />
          <Route path={PROCESS_VIEW_PATH} element={<PrivateRoute><GraphPage /></PrivateRoute>} />
          <Route path={ANALYTICS_VIEW_PATH} element={<PrivateRoute><AnalyticsPage /></PrivateRoute>} />
          <Route path={PROCESS_FLOW_PATH} element={<PrivateRoute><ProcessFlowPage /></PrivateRoute>} />
          <Route path={LEGACY_PROCESS_VIEW_PATH} element={<Navigate to={PROCESS_VIEW_PATH} replace />} />
          <Route path={LEGACY_ANALYTICS_VIEW_PATH} element={<Navigate to={ANALYTICS_VIEW_PATH} replace />} />
          <Route path="/admin/*" element={<PrivateRoute><GraphPage /></PrivateRoute>} />
          <Route path="*" element={<Home />} replace />
        </Routes>
      </React.Suspense>
    </TabProvider>
  );
};

const Router = () => {
  return (
    <HashRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppRoutes />
    </HashRouter>
  )
};

export default Router;
